import HttpClient from "./HttpClient";
import Address from "./Address";
import Contact from "./Contact";

export default class Customer {
  constructor(customer) {
    if (!customer) return;
    this.id = customer.id;
    this.type = customer.type;
    this.name = customer.name;
    this.vat_number = customer.vat_number;
    this.main_address = customer.main_address;
    this.phone = customer.phone;
    this.mobile = customer.mobile;
    this.email = customer.email;
    this.default_delivery_address = customer.default_delivery_address;
    this.pref_packing_type = customer.pref_packing_type;
    this.pallet_list_template = customer.pallet_list_template;
    this.truck_list_template = customer.truck_list_template;
    this.created_at = customer.created_at;
    this.updated_at = customer.updated_at;
    this.code = customer.code;
    this.pricing = customer.pricing;
    this.default_discount = customer.default_discount;
    this.short_name = customer.short_name;
    this.addresses = (customer.addresses) ? this.getAddresses(customer.addresses) : [];
    this.contacts = (customer.contacts) ? this.getContacts(customer.contacts) : [];
  }

  getAddresses(addresses){
    const objects = [];
    addresses.forEach(address => {
      objects.push(new Address(address));
    });
    return objects;
  }

  getContacts(contacts){
    const objects = [];
    contacts.forEach(contact => {
      objects.push(new Contact(contact));
    });
    return contacts;
  }

  static async loadCustomers(data){
    const client = new HttpClient();
    const response = await client.instance.get("customers", data);
    return {
      customers: response.data.data,
      page: response.data.current_page,
      pagesCount: response.data.last_page,
      itemsCount: response.data.total
    };
  }

  static async loadCustomer(customerId){
    const client = new HttpClient();
    const response = await client.instance.get(`customers/${customerId}`);
    return new Customer(response.data);
  }

  async save(data){
    const client = new HttpClient();
    const response = await client.instance.put(`customers/${this.id}`, data);
    return response.data;
  }

  async delete(){
    const client = new HttpClient();
    const response = await client.instance.delete(`customers/${this.id}`);
    return response.data;
  }

  toString(){
    if(!this.name) return "";
    return this.name;
  }
}
